var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.value)?_c('span',{class:_vm.trueClass},[_vm._v("Tak")]):_c('span',{class:_vm.falseClass},[_vm._v("Nie")])])}
var staticRenderFns = []

export { render, staticRenderFns }